import { useQuery } from '@tanstack/react-query';
import { fetchLookupPorts } from '@api';
import { useSelector } from 'react-redux';
import { getGeneralSlice } from '@store/features';

const comparePort = (a, b) => a.portName.localeCompare(b.portName);

export const useLookupPortsQuery = () => {
  const { segment } = useSelector(getGeneralSlice);
  return useQuery({
    queryKey: ['lookupPorts', { SegmentTypeId: segment?.id }],
    enabled: !!segment,
    placeholderData: [],
    queryFn: ({ signal }) =>
      fetchLookupPorts({ SegmentTypeId: segment.id }, signal)
        .then((resp) => resp.sort(comparePort))
        .catch(() => [])
  });
};
